module.exports = __webpack_public_path__ + "static/rc-9-59658d8d2969c296a76bc844e7ab1d54.jpg";